<ng-container>
  <mat-dialog-actions>
    <ng-container>
      @for (action of actions; track $index) {
        @if (
          action.actionType === actionType.ACTION_TYPE_SEND_REQUEST ||
          action.actionType === actionType.ACTION_TYPE_COPY ||
          action.actionType === actionType.ACTION_TYPE_SAVE ||
          action.actionType === actionType.ACTION_TYPE_EDIT ||
          action.actionType === actionType.ACTION_TYPE_ADD_CONNECTION ||
          action.actionType === actionType.ACTION_TYPE_CONTINUE
        ) {
          <button
            mat-flat-button
            color="primary"
            class="mat-mdc-unelevated-button"
            (click)="onActionClick(action.actionType)"
          >
            {{ action.label | translate }}
          </button>
        } @else {
          <button
            mat-button
            mat-dialog-close
            class="mdc-button--outlined mat-mdc-outlined-button"
            (click)="onActionClick(action.actionType)"
          >
            {{ action.label | translate }}
          </button>
        }
      }
    </ng-container>
  </mat-dialog-actions>
</ng-container>
